import React, { Component } from 'react';
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Button, Tooltip } from 'antd'
import DocumentView from '../document-view/DocumentView'
import SVGView from '../assets-view/SVGView';
import { VideoView } from '../assets-view/VideoView'
import { downloadProgress } from '../../actions/ClientAction'
import {
  // extensionValidateDownload,
  extValidateDownload,
  sendNotification,
  ENDPOINT,
  // uuidv4,
  // MAX_SIZE_DOWNLOAD_ZIP_FOLDER
} from '../../utils/index'
import './download-asset.css'
import { setkeyboardEnabled } from '../../actions/AppAction'
import {
  startDownload,
  handleShowProgressIndicator,
  handleRefreshDownloadHistory,
  updateDownload,
} from '../../actions/DownloadAction'
import BunkeyAPI from '../../api/BunkeyAPI'
import axios from 'axios'
import Socket from '../../utils/sockets'
import fileextension from 'file-extension'
export class DownloadAsset extends Component {
  constructor(props) {
    super(props)
    this.state = {
      extValidate: false,
      progressDownload: 0,
    }
  }

  componentDidMount() {
    const { itemSelected } = this.props
    // let ext = extensionValidateDownload(itemSelected.originalURL)
    let ext = extValidateDownload(itemSelected.originalURL, itemSelected);
    this.setState({
      extValidate: ext,
    });
    this.props.setkeyboardEnabled(true)
  }
  /**
   * @name handleDownload
   * @author Victor Smith
   */
  handleDownloadMultiple = async (quality) => {
    const { intl, selectedFiles } = this.props;
    Socket.getInstance().emit(
      'request_client_download_multiple'
    ,{
      id: Socket.getInstance().id,
      env: process.env.REACT_APP_BUNKEY_ENV ? process.env.REACT_APP_BUNKEY_ENV : 'qa',
      files: selectedFiles.map(e => ({
        name: e.name,
        uuid: e._id
      })),
      lang: intl.locale,
    });
  }
  handleDownload = async (quality, multiple = false) => {
    const { workclient, itemSelected, accessToken, intl } = this.props;
    // const uuid = uuidv4();
    // const id = itemSelected._id;

    console.log("falta implementar")
    console.log(workclient, itemSelected, accessToken, intl)

    return

    // this.props.handleHideDownloadDrawer();
    // this.props.startDownload({
    //   id: itemSelected._id,
    //   uuid: uuid,
    //   name: itemSelected.name,
    //   state: 'download_in_progress',
    //   client: !workclient
    //     ? itemSelected.client
    //     : workclient,
    //   quality,
    // });
    // let fileSize;
    // if (!workclient) {
    //   const resp = await axios.get(`${ENDPOINT}downloads/get-sizes?id=${id}`, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Authorization': `Bearer ${accessToken}`
    //     }
    //   });
    //   if(!resp.data) return;
    //   fileSize = resp.data[0].fileSize;
    // }else{
    //   const resp = await BunkeyAPI({
    //     url: `/downloads/get-sizes?id=${id}`,
    //     method: 'GET',
    //   });
    //   if(!resp.data) return;
    //   fileSize = resp.data[0].fileSize;
    // }
    // const toZip = fileSize > MAX_SIZE_DOWNLOAD_ZIP_FOLDER;
    // Socket.getInstance().emit(
    //   toZip ? 
    //     'request_client_download_not_zip_folder' : 
    //     'request_client_download'
    // ,{
    //   wc: !workclient
    //     ? itemSelected.client._id === undefined
    //       ? itemSelected.client
    //       : itemSelected.client._id
    //     : workclient,
    //   quality,
    //   asset: itemSelected._id,
    //   uuid,
    //   lang: intl.locale,
    //   channel: 'single',
    // });
  }


  handleSaveDownload = (id, status) => {
    const { workclient, intl, itemSelected, accessToken } = this.props
    if (!workclient) {

      const clientParam = itemSelected.client._id === undefined
        ? itemSelected.client
        : itemSelected.client._id

      axios.post(`${ENDPOINT}downloads/client/${clientParam} `, { asset: itemSelected._id, status }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        }
      })
        .then(resp => {
        })
        .catch(err => {
          sendNotification('error', intl, intl.formatMessage({ id: 'error_saving_download' }))
        })
    } else {
      BunkeyAPI({
        url: `/downloads/client/${workclient}`,
        method: 'POST',
        data: {
          asset: id,
          status,
        }
      }).then(resp => {
        this.props.handleRefreshDownloadHistory(true);
      }).catch(err => {
        sendNotification('error', intl, intl.formatMessage({ id: 'error_saving_download' }))
      })
    }
  }

  render() {
    const { itemSelected, newColor, intl, showIconExclamation, dataDownload } = this.props
    const { extValidate } = this.state
    const alreadyDownloading = dataDownload.find(f => f.id === itemSelected._id) !== undefined

    return (
      <React.Fragment>
        <div className='download-title' >
          <span> ¿{intl.formatMessage({ id: "download_drawer_question" })} {itemSelected.name}?</span>
        </div>
        <div className='download-asset' >

          {
            itemSelected.type === 'image' && fileextension(itemSelected.originalURL) === 'svg'
            && <SVGView comFromMiddleView={true} src={itemSelected.originalURL} assetId={itemSelected._id} />
          }

          {itemSelected.type === 'image' && fileextension(itemSelected.originalURL) !== 'svg' && <img
            alt={itemSelected.name}
            src={itemSelected.lowQualityURL}
            className="responsive-img" />}
          {itemSelected.type === 'video' && <VideoView
            url={itemSelected.lowQualityURL}
            disableDefaultControls={false}
            autoPlay={false}
            muted={true}
          />}
          {itemSelected.type === 'document' && <DocumentView
            item={itemSelected}
            from={`middleView`} />}
        </div>
        <div className='download-buttons' >
          {alreadyDownloading && <React.Fragment>
            <Tooltip title={alreadyDownloading ? intl.formatMessage({ id: "already_downloading_asset" }) : ''}>
              <Button
                onClick={() => this.handleDownload('original')}
                type="default"
                disabled={showIconExclamation || alreadyDownloading}
                block>Original</Button>
            </Tooltip>
            {extValidate && <Tooltip title={alreadyDownloading ? intl.formatMessage({ id: "already_downloading_asset" }) : ''}>
              <Button
                disabled={alreadyDownloading}
                onClick={() => this.handleDownload('medium')}
                type="default"
                block>{intl.formatMessage({ id: "optimized_version" })}</Button>
            </Tooltip>}
            <Button
              style={{ color: newColor, borderColor: newColor, width: '100%' }}
              onClick={this.props.handleHideDownloadDrawer}>{intl.formatMessage({ id: "cancel_button" })}</Button>
          </React.Fragment>}
          {!alreadyDownloading && <React.Fragment>
            <Tooltip
              title={!showIconExclamation ? '' : intl.formatMessage({ id: "rights_asset_out" })}
              defaultVisible={!showIconExclamation}>
              <Button
                onClick={() => this.handleDownload('original')}
                type="default"
                disabled={showIconExclamation || alreadyDownloading}
                block>Original</Button>
            </Tooltip>
            {extValidate && <Button
              disabled={alreadyDownloading}
              onClick={() => this.handleDownload('medium')}
              type="default"
              block>{intl.formatMessage({ id: "optimized_version" })}</Button>}
            <Button
              style={{ color: newColor, borderColor: newColor, width: '100%' }}
              onClick={this.props.handleHideDownloadDrawer}>{intl.formatMessage({ id: "cancel_button" })}</Button>
          </React.Fragment>}
        </div>
      </React.Fragment >
    )
  }
}

const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    workclient: state.client.workclient,
    id: state.app.resumeDownloadId,
    user: state.authUser.user,
    accessToken: state.assetsPublicShared.accessToken,
    dataDownload: state.downloads.data,
    selectedFiles: state.selectedFiles.data,
  }
}

const mapDispatchToProps = {
  downloadProgress,
  setkeyboardEnabled,
  startDownload,
  handleShowProgressIndicator,
  handleRefreshDownloadHistory,
  updateDownload,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(DownloadAsset)))
